import { doNotTranslate } from 'util/misc'

export const WEATHER_DATASET_AUTO = 6

export const WEATHER_DATASETS = [
  {
    id: WEATHER_DATASET_AUTO,
    name: 'Best Available',
    translate: true,
    configuration_level_only: true,
  },
  {
    id: 0,
    name: 'EnergyPlus',
  },
  {
    id: 1,
    name: 'PVGIS',
  },
  {
    id: 2,
    name: 'NREL PSM4 (US Only)',
    restrict_to_country: ['US'],
  },
  {
    id: 3,
    name: 'CSIRO',
    restrict_to_country: ['AU'],
  },
  {
    id: 4,
    name: 'Himawari PSM3',
    restrict_to_country: ['AU'],
  },
  {
    id: 5,
    name: 'SUNY India',
    // Same CSV index (suny_india/); offered for India and neighbouring markets
    restrict_to_country: ['IN', 'LK', 'BT', 'BD', 'NP'],
  },
]

export const PSM4_DATASET_ID = 2
export const HIMAWARI_DATASET_ID = 4

export const getWeatherDatasetChoices = (
  selectedDataset: number | undefined | null,
  country_iso2: string,
  excludedDatasets: number[] = [],
  isProjectConfiguration: boolean = false
) => {
  return WEATHER_DATASETS.filter((dataset) => {
    if (!isProjectConfiguration && dataset.configuration_level_only === true) {
      return false
    }
    if (selectedDataset === dataset.id) {
      return true
    }
    if (excludedDatasets.includes(dataset.id)) {
      return false
    }
    if (dataset.restrict_to_country) {
      return dataset.restrict_to_country.includes(country_iso2)
    } else {
      return true
    }
  })
}

export const translateWeatherDatasets = (datasets: typeof WEATHER_DATASETS, translate: (term: string) => string) => {
  return datasets.map((wd) => ({
    ...wd,
    name: wd.translate ? translate(wd.name) : doNotTranslate(wd.name),
  }))
}
